import styled from 'styled-components';

export const AiAssistantStyled = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;

  .consultantBtnContainer {
    top: 0;
    z-index: 3;
    background: white;
  }

  .consultantBtn {
    width: fit-content;
    display: flex;
    align-items: center;
    gap: 4px;
    border-radius: 12px;
    padding: 8px 8px 8px 12px;
    background: #ffe6f0;
    cursor: pointer;
  }

  .subtitleBold {
    font-weight: 700;
  }

  .aiAssistantContent {
    position: relative;
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    gap: 16px;
    padding: 32px 16px 16px;

    .aiIcon {
      width: 50px;
      height: 50px;
    }
  }

  .aiQnaArea {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .qContentArea {
    position: sticky;
    bottom: 0;
    width: 100%;
    display: flex;
    gap: 10px;
    padding: 8px 16px;
    background: white;
    z-index: 2;
  }

  .aiAssistantInfoContainer {
    width: 100%;
    background: white;
    z-index: 1;
    padding: 8px 24px 44px;
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .aiQuestionBox,
  .aiAnswerBox,
  .aiFailBox,
  .aiLoadingBox {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    align-self: stretch;
    animation: fadeIn 0.3s ease-in-out;

    @keyframes fadeIn {
      from {
        opacity: 0;
      }
      to {
        opacity: 1;
      }
    }

    > div {
    }

    .contentBox {
      min-height: 36px;
      display: flex;
      padding: 8px;
      align-items: center;
      gap: 10px;
      flex: 1 0 0;
      border-radius: 8px;
      background: var(--GrayScale-100, #f5f5f5);
      overflow-x: auto;
    }

    > img {
      width: 36px;
      height: 36px;
    }
  }

  .aiLoadingBox {
    width: 100%;

    .skeletonBox {
      flex: 1;
      border-radius: 8px;
      background: var(--GrayScale-100, #f5f5f5);
      overflow: hidden;
    }

    .skeletonContent {
      background: linear-gradient(90deg, #f0f0f0 0%, #e0e0e0 50%, #f0f0f0 100%);
      background-size: 200% 100%;
      animation: shimmer 1.5s infinite ease-in-out;
      min-height: 36px;
      display: flex;
      padding: 8px;
      align-items: center;
      width: 100%;
    }
  }

  @keyframes shimmer {
    0% {
      background-position: 200% 0;
    }
    100% {
      background-position: -200% 0;
    }
  }

  .aiAnswerBox,
  .aiFailBox {
    flex-direction: column;
    gap: 5px;

    > div {
      width: 100%;
    }

    .answerBtnBox {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      gap: 8px;
      padding-left: 44px;
    }

    .answerBtnToggle {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      padding: 4px 0;
      cursor: pointer;

      span {
        font-family: 'Pretendard', sans-serif;
        font-size: 12px;
        font-weight: 500;
        line-height: 18px;
        color: #999999;
      }

      &:hover span {
        color: #666666;
      }
    }

    .answerBtn {
      display: flex;
      align-items: center;
      gap: 4px;
      background: #ffffff;
      border: 1px solid var(--GrayScale-300, #e9e9e9);
      border-radius: 23px;
      padding: 4px 13px 4px 6px;
      box-shadow: 2px 2px 4px 0 rgba(0, 0, 0, 0.1);

      .answerBtnImgBox {
        display: flex;
        align-items: center;
        width: 25px;
        height: 25px;
      }

      p {
        font-family: 'Pretendard', sans-serif;
        font-size: 12px;
        font-style: normal;
        font-weight: 500;
        line-height: 18px;
      }
    }

    .sampleImgBox {
      padding: 8px;
      border: 1px solid var(--GrayScale-300, #e9e9e9);
      border-radius: 10px;
      background: #ffffff;
      width: calc(100% - 44px);
      margin-left: 44px;

      img {
        width: 100%;
        height: auto;
      }
    }
  }

  // 답변 조각
  .contentPieces {
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;
    word-break: break-all;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }

  .contentPieces * {
    font-size: 14px;
    word-break: break-all;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }

  .answerFormula {
    width: 100%;
    overflow-x: auto;
    overflow-y: hidden;
    margin-bottom: 5px;

    &::-webkit-scrollbar {
      width: 0;
      height: 5px;
    }

    &::-webkit-scrollbar-track {
      background: transparent;
    }

    &::-webkit-scrollbar-thumb {
      background-color: rgba(245, 245, 245, 0.8);
      transition: background-color 0.2s ease;
      border-radius: 3px;
      cursor: pointer;
      padding-top: 5px;
    }

    &:hover::-webkit-scrollbar-thumb,
    &:focus::-webkit-scrollbar-thumb {
      background-color: rgba(204, 204, 204, 0.8);
    }

    .katex-display {
      display: inline-block;
      min-width: min-content;
      max-width: 100%;
      margin: 0;
    }

    .katex {
      display: inline-block;
      white-space: nowrap;
    }

    .base {
      display: inline-block;
      white-space: nowrap;
    }
  }

  // 수식 내부 텍스트 요소
  .katex * {
    color: #333333;
    /* text-align: left; */
  }

  @keyframes pulse-fade {
    0% {
      transform: scale(1);
      opacity: 1;
    }

    50% {
      transform: scale(0.9);
      opacity: 0.7;
    }

    100% {
      transform: scale(1);
      opacity: 1;
    }
  }

  .aiResponding {
    animation: pulse-fade 1s ease-in-out infinite;
  }

  /* AI 워터마크 - 대화 전 상태 */
  .aiWatermark {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 24px;
    z-index: 0;
    width: 100%;
  }

  .watermarkText {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    text-align: center;
  }

  .watermarkTitle {
    font-size: 18px;
    font-weight: 700;
    line-height: 28px;
    color: #999999;
  }

  .watermarkDesc {
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    color: #999999;
  }

  .watermarkCounselorBtn {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    padding: 8px 12px;
    border-radius: 12px;
    background: #ffe6f0;
    cursor: pointer;
  }

  .watermarkCounselorBtn span {
    font-size: 14px;
    font-weight: 600;
  }

  .watermarkCounselorBtn img {
    width: 20px;
    height: 20px;
  }
`;
